<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div *ngIf="mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <td style="
                                padding-left:4%;
                                padding-right:4%;
                                padding-top: 5%;
                                padding-bottom: 3%;">

                        <!-- Home / Information / About Backseat Trader and eToro<br/> -->
                        <h1 style="color: #5ECE42">About Backseat Trader & eToro</h1><br />
                        Backseat Trader is a comprehensive online web portal designed to help novice and experienced
                        investors navigate
                        the often-turbulent world of stock trading and investments. The web portal, along with its
                        mobile
                        app, focuses
                        on providing its users with data-driven insights, educational resources, and access to a
                        supportive
                        online
                        community to empower them in making informed decisions about their investment strategies.
                        Through
                        the eToro
                        'Popular Investor Programme', a leading social trading and multi-asset brokerage company,
                        Backseat
                        Trader
                        enhances its offerings to users, providing access to a wide range of investment opportunities
                        and
                        advanced
                        trading tools.
                        <br /><br />
                        One of the key features of Backseat Trader is its proprietary trading algorithm, which uses
                        advanced
                        analytical
                        techniques to analyse vast amounts of market data. This cutting-edge technology helps identify
                        patterns and
                        trends that may be difficult for human traders to discern, offering Copy-Traders the opportunity
                        to
                        capitalise
                        on profitable trades. The algorithm is continuously updated to stay abreast of the latest market
                        developments,
                        ensuring its Copy-Traders that the algorithm has the most up-to-date information as it trades
                        its
                        stock
                        portfolio on the eToro platform.
                        <br /><br />
                        As part of being a Popular Investor with eToro, the Backseat Trader algorithm specifically
                        targets a
                        selection
                        of the top 20 stocks chosen from the Nasdaq-100 index. This combined infrastructure enables
                        Copy-Traders to
                        access and invest in these high-performing stocks while leveraging eToro's user-friendly
                        platform
                        and social
                        trading features. The integration of the algorithm's curated stock selection into eToro's
                        platform
                        allows
                        Copy-Traders to benefit from data-driven insights and optimise their investment returns.
                        <br /><br />
                        Another core component of the Backseat Trader web portal is its extensive educational content.
                        The
                        platform is
                        committed to providing its Copy-Traders with a solid foundation in investment strategies, risk
                        <span scrolledTo #scrolledToElement="scrolledTo"></span>
                        management, and
                        financial planning. The website offers a diverse range of materials, including articles, video
                        content as
                        produced by eToro and regular report updates as the algorithm trades through both positive and
                        negative
                        territory, expeditiously mitigating losses on the downside, whilst, chasing gains to the upside.
                    </td>
                </tr>
            </table>
        </div><br />
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

        <section class="linkedIn">
            <div class="shell">
                <div class="section__content">
                    <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                        rel="noopener noreferrer"><img class="linkedImg"
                            src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn" /></a>
                </div>
            </div>
        </section>
    </div>
    <div [class.sticky2-mob-stop]="scrolledToElement.reached" [class.sticky2-mob]="scrolledToElement.notreached">
        <div class="row">
            <div class="col-auto" style="align-items: center;
            display: grid;margin-left:2%">

                <i [routerLink]="['/']" fragment="about" class="fa-solid fa-arrow-left fa-3x"></i>
            </div>
            <div class="col" style="width: 70%;">

                <audio controls>
                    <source src="https://theapi.backseat-trader.com/About eToro.mp3"
                        type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>
            </div>
            <div class="col-auto" style="align-items: center;
            display: grid;margin-right:2%">

                <i [routerLink]="['/']" class="fa-solid fa-house fa-3x" (click)="removePos()"></i>
            </div>
        </div>

    </div>
</div>

<div *ngIf="!mobile">
    <div class="template" style="font-size:large">
        <div>

            <table>
                <tr>
                    <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                <tr>
                    <td>
                        <audio controls>
                            <source
                                src="https://theapi.backseat-trader.com/About eToro.mp3"
                                type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i [routerLink]="['/']" fragment="about" class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
                <br/>
                <tr>
                    <td>
                        <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">About Backseat Trader and eToro</span><br/>
                    </td>
                </tr>

        </div>

        </td>
        <td style="width: 79%;
                    padding-right: 19%;
                    padding-top: 3%;
                    padding-bottom: 3%;">
             <!-- <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">About Backseat Trader and eToro</span><br/> -->
            <h1 style="color: #5ECE42">About Backseat Trader & eToro</h1><br />
            Backseat Trader is a comprehensive online web portal designed to help novice and experienced
            investors navigate
            the often-turbulent world of stock trading and investments. The web portal, along with its mobile
            app, focuses
            on providing its users with data-driven insights, educational resources, and access to a supportive
            online
            community to empower them in making informed decisions about their investment strategies. Through
            the eToro
            'Popular Investor Programme', a leading social trading and multi-asset brokerage company, Backseat
            Trader
            enhances its offerings to users, providing access to a wide range of investment opportunities and
            advanced
            trading tools.
            <br /><br />
            One of the key features of Backseat Trader is its proprietary trading algorithm, which uses advanced
            analytical
            techniques to analyse vast amounts of market data. This cutting-edge technology helps identify
            patterns and
            trends that may be difficult for human traders to discern, offering Copy-Traders the opportunity to
            capitalise
            on profitable trades. The algorithm is continuously updated to stay abreast of the latest market
            developments,
            ensuring its Copy-Traders that the algorithm has the most up-to-date information as it trades its
            stock
            portfolio on the eToro platform.
            <br /><br />
            As part of being a Popular Investor with eToro, the Backseat Trader algorithm specifically targets a
            selection
            of the top 20 stocks chosen from the Nasdaq-100 index. This combined infrastructure enables
            Copy-Traders to
            access and invest in these high-performing stocks while leveraging eToro's user-friendly platform
            and social
            trading features. The integration of the algorithm's curated stock selection into eToro's platform
            allows
            Copy-Traders to benefit from data-driven insights and optimise their investment returns.
            <br /><br />
            Another core component of the Backseat Trader web portal is its extensive educational content. The
            platform is
            committed to providing its Copy-Traders with a solid foundation in investment strategies, risk
            management, and
            financial planning. The website offers a diverse range of materials, including articles, video
            content as
            produced by eToro and regular report updates as the algorithm trades through both positive and
            negative
            territory, expeditiously mitigating losses on the downside, whilst, chasing gains to the upside.
        </td>
        </tr>
        </table>
    </div>

    <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

    <section class="linkedIn">
        <div class="shell">
            <div class="section__content">
                <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                    rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png"
                        alt="Follow us on LinkedIn" /></a>
            </div>
        </div>
    </section>
</div>
</div>